import { FaStar } from "react-icons/fa";
import ExploreCardChips from "./ExploreCardChips";
import Line from "./Line";
import { Button } from "@mui/material";
import { EastRounded } from "@mui/icons-material";
import ExploreOtherSection from "./ExploreOtherSection";

export function ExploreCard({ isAdCard, cardIndex }) {
  if (isAdCard) {
    // Render ad card content
    return <ExploreOtherSection />;
  }

  return (
    <div className=" mt-6 max-w-[410px] rounded-md border shadow-[0px_5px_16px_rgba(0,0,0,0.06)]">
      <div className="flex p-2">
        <img
          src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&amp;ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGh1bWFufGVufDB8fDB8fA%3D%3D&amp;auto=format&amp;fit=crop&amp;w=800&amp;q=60"
          alt="Laptop"
          className="w-[154px] h-[157px] rounded-md object-cover"
        />
        <div className="pl-2">
          <h1 className="text-lg font-semibold flex">
            Dr. Payal Bhatra <span className="text-sm h-6 w-6"></span>
          </h1>

          <h6 className="mt-1 font-medium text-[12px]">Designation</h6>
          <p className="mt-1 text-sm font-semibold">
            Co-founder and Creative head Sygnific Careers/ Surgeon
          </p>
          <div className="mt-4 flex flex-wrap text-center">
            <div className="flex justify-center items-center text-center gap-2 bg-[#F2F2F2] rounded-[6px] p-[6px] ">
              <FaStar className="text-[#F0D41B] text-[16px]" />
              <span className="text-[#000000] font-bold">4.5</span>
            </div>
            <h5 className="text-[#239403] underline underline-offset-4 m-2">
              35k+ Reviews
            </h5>
          </div>
        </div>
      </div>
      <div className="flex justify-between px-2">
        <ExploreCardChips />
        <ExploreCardChips />
        <ExploreCardChips />
      </div>
      <div className="my-3">
        <Line />
      </div>
      <div className="flex justify-between text-center mb-2  px-1">
        <h4 className="text-[#000000] text-[23px] font-extrabold">
          $2000/
          <span className="text-[13px] font-normal">per month</span>
        </h4>
        <Button
          variant="contained"
          className="border py-[19px] flex gap-[6.2px] miniDesk:!px-[2px] text-[19px] font-medium capitalize !text-[#000000] !bg-[#F0BC5E52] 3xl:py-[10px]  3xl:px-3 3xl:text-[13px] 3xl:h-fit !shadow-none px-[28px] border-[#239403] rounded-[9px]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22.151"
            height="22.558"
            viewBox="0 0 22.151 22.558"
          >
            <g id="chat_2_" data-name="chat (2)" transform="translate(0)">
              <g id="Group_411891" data-name="Group 411891">
                <path
                  id="Path_266927"
                  data-name="Path 266927"
                  d="M14.493,0h-.036A11.066,11.066,0,0,0,5.778,17.963L4.164,21.716a.6.6,0,0,0,.314.792.614.614,0,0,0,.345.042l5.917-1.04a10.663,10.663,0,0,0,3.687.641A11.076,11.076,0,0,0,14.493,0ZM10.7,8.861h3.264a.6.6,0,0,1,0,1.209H10.7a.6.6,0,1,1,0-1.209Zm7.495,4.231H10.7a.6.6,0,1,1,0-1.209h7.495a.6.6,0,1,1,0,1.209Z"
                  transform="translate(-3.366)"
                />
              </g>
            </g>
          </svg>
          Start Chat
          {/* <EastRounded className="3xl:text-[16px] miniDesk:hidden" /> */}
        </Button>
        <Button
          variant="contained"
          className="border py-[19px] flex gap-[6.2px] miniDesk:!px-[2px] text-[19px] font-medium capitalize !text-[#000000] !bg-[#F0BC5E] 3xl:py-[10px]  3xl:px-3 3xl:text-[13px] 3xl:h-fit !shadow-none px-[28px] border-[#239403] rounded-[9px]"
        >
          Buy Now <EastRounded className="3xl:text-[16px] miniDesk:hidden" />
        </Button>
      </div>
    </div>
  );
}
